jQuery(document).ready(function ($) {
  //Hide search in menu on front page
  if (window.location.pathname == "/") {
    jQuery(".search-icon-sub").remove();
  }

  /*------------------------------------------------------*/
  //Toggle search
  jQuery("body").on("click", ".search-icon-sub", function () {
    jQuery("body").find(".search-bar-sub").toggleClass("showMe");
  });
  // Bind Enter key to click this
  $(".search-icon-sub").keyup(function (e) {
    if (e.keyCode == 13) {
      $(this).click();
    }
  });

  // jQuery('body.search-hemsidan .search-icon-sub').click(function(){
  //   jQuery('search-bar-sub').toggleClass('showMe');
  // });

  // Main searchengine effect
  jQuery('.searchengine input[type="text"]')
    .blur(function () {
      jQuery(".searchengine").removeClass("focus");
    })
    .focus(function () {
      jQuery(".searchengine").addClass("focus");
    });

  // Make all input fileds disabled by default, except Hela hemsidan
  jQuery(
    ".search-form input.input-amnesomraden,.search-form input.input-blanketter,.search-form input.input-taxor,.search-form input.input-rapporter,.search-form input.input-aktuellt"
  )
    .hide()
    .prop("disabled", true);
});

// set searchaction depending on value of select
jQuery(".searchengine select").change(function () {
  var action = jQuery(this).val();
  if (action === "hemsidan") {
    jQuery(".search-form").attr("action", "/search-" + action);
    jQuery(".search-form input.input-hemsidan").show().prop("disabled", false);
    jQuery(
      ".search-form input.input-amnesomraden,.search-form input.input-blanketter,.search-form input.input-taxor,.search-form input.input-rapporter,.search-form input.input-aktuellt"
    )
      .hide()
      .prop("disabled", true);
  } else if (action == "amnesomraden") {
    jQuery(".search-form").attr("action", "/search-" + action);
    jQuery(".search-form input.input-amnesomraden")
      .show()
      .prop("disabled", false);
    jQuery(
      ".search-form input.input-hemsidan,.search-form input.input-blanketter,.search-form input.input-taxor,.search-form input.input-rapporter,.search-form input.input-aktuellt"
    )
      .hide()
      .prop("disabled", true);
  } else if (action == "aktuellt") {
    jQuery(".search-form").attr("action", "/search-" + action);
    jQuery(".search-form input.input-aktuellt").show().prop("disabled", false);
    jQuery(
      ".search-form input.input-hemsidan,.search-form input.input-blanketter,.search-form input.input-taxor,.search-form input.input-rapporter,.search-form input.input-amnesomraden"
    )
      .hide()
      .prop("disabled", true);
  } else if (action == "blanketter") {
    jQuery(".search-form").attr("action", "/search-" + action);
    jQuery(".search-form input.input-blanketter")
      .show()
      .prop("disabled", false);
    jQuery(
      ".search-form input.input-hemsidan,.search-form input.input-aktuellt,.search-form input.input-taxor,.search-form input.input-rapporter,.search-form input.input-amnesomraden"
    )
      .hide()
      .prop("disabled", true);
  } else if (action == "taxor") {
    jQuery(".search-form").attr("action", "/search-" + action);
    jQuery(".search-form input.input-taxor").show().prop("disabled", false);
    jQuery(
      ".search-form input.input-hemsidan,.search-form input.input-blanketter,.search-form input.input-aktuellt,.search-form input.input-rapporter,.search-form input.input-amnesomraden"
    )
      .hide()
      .prop("disabled", true);
  } else if (action == "rapporter") {
    jQuery(".search-form").attr("action", "/search-" + action);
    jQuery(".search-form input.input-rapporter").show().prop("disabled", false);
    jQuery(
      ".search-form input.input-hemsidan,.search-form input.input-blanketter,.search-form input.input-aktuellt,.search-form input.input-taxor,.search-form input.input-amnesomraden"
    )
      .hide()
      .prop("disabled", true);
  }
});
